(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/persist-games-middleware.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/persist-games-middleware.js');
"use strict";

const _excluded = ["isHuxfluxed"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

const Storage = svs.components.Storage;
const _svs$gamePackage$data = svs.gamePackage.data.packageConfig,
  title = _svs$gamePackage$data.title,
  packageSizes = _svs$gamePackage$data.packageSizes;
const config = {
  domain: 'gamePackage',
  expires: Storage.constants.EXPIRES_15M
};

function getKeyName(index) {
  return "".concat(title, "_").concat(packageSizes[index].label);
}

const loadGamesFromLocalStorage = _ref => {
  let index = _ref.index;
  const domain = config.domain;
  const key = getKeyName(index);
  return Storage.browser.get(key, domain);
};

const saveGamesToLocalStorage = _ref2 => {
  let index = _ref2.index,
    games = _ref2.games,
    onSaved = _ref2.onSaved;
  const domain = config.domain,
    expires = config.expires;
  const key = getKeyName(index);
  Storage.browser.set(key, domain, games, expires, onSaved);
};

const removeGamesFromLocalStorage = _ref3 => {
  let index = _ref3.index,
    onRemoved = _ref3.onRemoved;
  const domain = config.domain;
  const key = getKeyName(index);
  return Storage.browser.remove(key, domain, onRemoved);
};

const selectGamePropsToPersist = _ref4 => {
  let isHuxfluxed = _ref4.isHuxfluxed,
    persistRest = _objectWithoutProperties(_ref4, _excluded);
  return persistRest;
};

const persistGamesMiddleware = store => next => action => {
  const updateIndex = svs.gamePackage.redux.gamePackageSlice.actions.updateIndex;
  const huxflux = svs.gamePackage.redux.numbergamesSlice.actions.huxflux;
  switch (action.type) {
    case updateIndex().type:
      {
        Storage.browser.get(getKeyName(action.payload.activeIndex), config.domain, (persistedGames, err) => {
          if (err) {
            next(action);
          } else if (persistedGames) {
            action.payload.persistedGames = persistedGames;
            next(action);
          } else {
            next(action);
            saveGamesToLocalStorage({
              index: store.getState().gamePackage.activeIndex,
              games: store.getState().numbergames.games
            });
          }
        });
        break;
      }
    case huxflux().type:
      {
        next(action);
        const activeIndex = store.getState().gamePackage.activeIndex;
        saveGamesToLocalStorage({
          index: activeIndex,
          games: store.getState().numbergames.games.map(selectGamePropsToPersist)
        });
        break;
      }
    default:
      next(action);
  }
};
svs.gamePackage.redux.middlewares = {
  loadGamesFromLocalStorage,
  saveGamesToLocalStorage,
  removeGamesFromLocalStorage,
  persistGamesMiddleware
};

 })(window);